
export default function AlertCountBubble({totalUnreadMessages}) {
  return (
    <div className={`flex justify-center items-center ${totalUnreadMessages > 0 ? 'bg-red-500 ' : 'bg-stone-600'} px-1.5 h-[1.5em] min-w-[1.5em] rounded-full font-bold text-white`}>{totalUnreadMessages}</div>
  );
};
